import useIntegrationsStore from '../../../../../store/Integrations';
import GlobalButton from '../../../../ui/GlobalButton';
import { ROUTES } from '@/routes';
import { useNavigate } from 'react-router-dom';

export default function SlackBanner() {
  const { updateSelectedIntegration } = useIntegrationsStore();
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-start">
      <div className="flex items-start gap-2">
        <div>
          <SlackIcon />
        </div>
        <small className="text-text-primary-body text-[10px] 2xl:text-[12px] 3xl:text-sm">
          Connect Slack to surface blockers and updates across teams.
        </small>
      </div>

      <div className="mt-4 w-full">
        <GlobalButton
          onClick={() => {
            updateSelectedIntegration('Slack');
            navigate(ROUTES.SLACK_INTEGRATION);
          }}
          variant={'purpleStroke'}
          state={'default'}
          size={'sm'}
          className={'text-sm'}
        >
          Integrate Slack
        </GlobalButton>
      </div>
    </div>
  );
}

const SlackIcon = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_ii_9108_1574)">
        <path
          d="M0.5 4.85107C0.5 2.64193 2.29086 0.851074 4.5 0.851074H17.1667C19.3758 0.851074 21.1667 2.64194 21.1667 4.85107V17.5177C21.1667 19.7269 19.3758 21.5177 17.1667 21.5177H4.5C2.29086 21.5177 0.5 19.7269 0.5 17.5177V4.85107Z"
          fill="#0E0E0E"
        />
        <path
          d="M4.5 1.08838H17.167C19.2448 1.08855 20.9287 2.77321 20.9287 4.85107V17.5181C20.9285 19.5958 19.2447 21.2796 17.167 21.2798H4.5C2.42214 21.2798 0.73748 19.5959 0.737305 17.5181V4.85107C0.737305 2.7731 2.42203 1.08838 4.5 1.08838Z"
          stroke="#3E3E3E"
          stroke-width="0.475"
        />
        <path
          d="M7.1748 12.8564C7.1748 13.5917 6.58051 14.186 5.84521 14.186C5.10991 14.186 4.51562 13.5917 4.51562 12.8564C4.51562 12.1211 5.10991 11.5269 5.84521 11.5269H7.1748V12.8564Z"
          fill="#E01E5A"
        />
        <path
          d="M7.83984 12.8564C7.83984 12.1211 8.43413 11.5269 9.16943 11.5269C9.90473 11.5269 10.499 12.1211 10.499 12.8564V16.1804C10.499 16.9157 9.90473 17.51 9.16943 17.51C8.43413 17.51 7.83984 16.9157 7.83984 16.1804V12.8564Z"
          fill="#E01E5A"
        />
        <path
          d="M9.16943 7.51806C8.43413 7.51806 7.83984 6.92378 7.83984 6.18847C7.83984 5.45317 8.43413 4.85889 9.16943 4.85889C9.90473 4.85889 10.499 5.45317 10.499 6.18847V7.51806H9.16943Z"
          fill="#36C5F0"
        />
        <path
          d="M9.16949 8.19287C9.90479 8.19287 10.4991 8.78716 10.4991 9.52246C10.4991 10.2578 9.90479 10.852 9.16949 10.852H5.83545C5.10014 10.852 4.50586 10.2578 4.50586 9.52246C4.50586 8.78716 5.10014 8.19287 5.83545 8.19287H9.16949Z"
          fill="#36C5F0"
        />
        <path
          d="M14.498 9.52246C14.498 8.78716 15.0923 8.19287 15.8276 8.19287C16.5629 8.19287 17.1572 8.78716 17.1572 9.52246C17.1572 10.2578 16.5629 10.852 15.8276 10.852H14.498V9.52246Z"
          fill="#2EB67D"
        />
        <path
          d="M13.833 9.52251C13.833 10.2578 13.2387 10.8521 12.5034 10.8521C11.7681 10.8521 11.1738 10.2578 11.1738 9.52251V6.18847C11.1738 5.45317 11.7681 4.85889 12.5034 4.85889C13.2387 4.85889 13.833 5.45317 13.833 6.18847V9.52251Z"
          fill="#2EB67D"
        />
        <path
          d="M12.5034 14.8508C13.2387 14.8508 13.833 15.4451 13.833 16.1804C13.833 16.9157 13.2387 17.51 12.5034 17.51C11.7681 17.51 11.1738 16.9157 11.1738 16.1804V14.8508H12.5034Z"
          fill="#ECB22E"
        />
        <path
          d="M12.5034 14.186C11.7681 14.186 11.1738 13.5917 11.1738 12.8564C11.1738 12.1211 11.7681 11.5269 12.5034 11.5269H15.8375C16.5728 11.5269 17.167 12.1211 17.167 12.8564C17.167 13.5917 16.5728 14.186 15.8375 14.186H12.5034Z"
          fill="#ECB22E"
        />
      </g>
      <defs>
        <filter
          id="filter0_ii_9108_1574"
          x="0.5"
          y="-2.94893"
          width="20.666"
          height="26.3667"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-4.75" />
          <feGaussianBlur stdDeviation="1.9" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_9108_1574"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="0.475"
            operator="erode"
            in="SourceAlpha"
            result="effect2_innerShadow_9108_1574"
          />
          <feOffset dy="2.375" />
          <feGaussianBlur stdDeviation="0.7125" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_innerShadow_9108_1574"
            result="effect2_innerShadow_9108_1574"
          />
        </filter>
      </defs>
    </svg>
  );
};
